import React from "react";
import Header from "../components/header/header";
import AppDevelopment from "../sections/AppDevelopment/AppDevelopment";
import Footer from "../components/footer/footer";
function Appdev() {
  return (
    <>
      <Header />
      <AppDevelopment />
      <Footer />
    </>
  );
}

export default Appdev;
